module.exports = __webpack_public_path__ + "static/media/car5.fb82b212.svg";